 $(document).ready(function () {
  $('input.get-rates.action_button.continue-button').click(function () {
$('div#wrapper-response').css("display","block");
    if (!$("#address_zip").val()) {
     console.log(1);
    } else {

  setTimeout(function () {
if ($("#wrapper-response").children().length > 0) {
console.log(1);
}
else{
    $('div#wrapper-response').html('<p class="loading_result">Please Wait .......</p>');    
      setTimeout(function () {

        $(".loading_result").remove();
      }, 6000);

    }
}, 2500);
    }
  });




function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    // Check if "varient" parameter exists in the URL
    var varientValue = getParameterByName('variant');
    if (varientValue !== null) {
        // "varient" parameter exists, show alert
        console.log('not');
    }else{
var product_name = $('.product_name').text();
setTimeout(function () {
  if(product_name == 'Quill'){

$('.swatch_options .swatch.clearfix.color input.v-swatch:nth-child(4)').trigger('click');
    setTimeout(function () {
$('.swatch_options .swatch.clearfix.color input.v-swatch:nth-child(2)').trigger('click');
       }, 1500);
}
    }, 2000);
    }


   
});

$(document).on("click", "span.pagination-button.page-num", function () {

 window.scrollTo(0, 0);
    
});

